import { InjectionToken } from '@angular/core';

export const defaultErrors = {
  required: (error) => `This field is required`,
  minlength: (params) => 'The minimum number of characters is ' + params.requiredLength,
  minLengthPassword: (params) => 'Password must contain at least ' + params + ' characters',
  numericPassword: () => 'Password should not be entirely numeric',
  commonPassword: () => 'Password is too common',
  maxlength: (params) => 'The maximum allowed number of characters is ' + params.requiredLength,
  invalid_characters: (params) => params.message,
  exists: (params) =>
    params.message || 'Entity with such name already exists, please enter different name.',
  email: () => 'Wrong email address.',
  phone: () => 'Wrong phone number',
  pattern: () => 'Wrong pattern',
  date: () => 'Invalid date',
  containLettersNumbersMurks: () =>
    'Password should contains letters, numbers, and punctuation marks',
};

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => defaultErrors,
});
